<template>
    <div class="insight-tags">
        <ul class="insight-tags--list u-reset">
            <li
                    class="insight-tags--item"
                    v-for="(tag, index) in filteredTags"
                    :id="'tag-' + tag.id"
                    :key="index">
                <a :href="generateTagLink(tag)" class="insight-tags--item-link u-reset">
                    {{ tag.title }}
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        props: {
            tags: {
                type: Array,
                default: () => [],
            },
            url: {
                type: String,
                default: window.location.pathname,
            },
        },
        computed: {
            filteredTags() {
                if (this.tags.length <= 0) {
                    return [];
                }

                return this.tags.filter(tag => tag.visible);
            },
        },
        methods: {
            generateTagLink(tag) {
                return `${ this.url }?query=${ encodeURIComponent(tag.title) }`;
            },
        },
    };
</script>
